import { render } from "./ExaminationFooterComponent.vue?vue&type=template&id=68fea249&scoped=true"
import script from "./ExaminationFooterComponent.vue?vue&type=script&lang=js"
export * from "./ExaminationFooterComponent.vue?vue&type=script&lang=js"

import "./ExaminationFooterComponent.vue?vue&type=style&index=0&id=68fea249&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fea249"]])

export default __exports__